import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.darkSage
};
export default anchor;